var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalCoupons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33955 18.3817L25.6056 1.47792L48.8717 18.3817L39.9848 45.7326H11.2264L2.33955 18.3817Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.5V19C15 18.7348 15.1054 18.4804 15.2929 18.2929C15.4804 18.1054 15.7348 18 16 18H34C34.2652 18 34.5196 18.1054 34.7071 18.2929C34.8946 18.4804 35 18.7348 35 19V24.5C34.337 24.5 33.7011 24.7634 33.2322 25.2322C32.7634 25.7011 32.5 26.337 32.5 27C32.5 27.663 32.7634 28.2989 33.2322 28.7678C33.7011 29.2366 34.337 29.5 35 29.5V35C35 35.2652 34.8946 35.5196 34.7071 35.7071C34.5196 35.8946 34.2652 36 34 36H16C15.7348 36 15.4804 35.8946 15.2929 35.7071C15.1054 35.5196 15 35.2652 15 35V29.5C15.663 29.5 16.2989 29.2366 16.7678 28.7678C17.2366 28.2989 17.5 27.663 17.5 27C17.5 26.337 17.2366 25.7011 16.7678 25.2322C16.2989 24.7634 15.663 24.5 15 24.5ZM17 22.968C17.7512 23.3403 18.3835 23.9151 18.8255 24.6275C19.2675 25.3399 19.5018 26.1616 19.5018 27C19.5018 27.8384 19.2675 28.6601 18.8255 29.3725C18.3835 30.085 17.7512 30.6597 17 31.032V34H33V31.032C32.2488 30.6597 31.6165 30.085 31.1745 29.3725C30.7325 28.6601 30.4982 27.8384 30.4982 27C30.4982 26.1616 30.7325 25.3399 31.1745 24.6275C31.6165 23.9151 32.2488 23.3403 33 22.968V20H17V22.968ZM22 24H28V26H22V24ZM22 28H28V30H22V28Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H28V26H22V24ZM22 28H28V30H22V28Z",
    fill: "#3D8ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCoupons);
export default __webpack_public_path__ + "static/media/digital-coupons.334fb05334882c86eb3b9a55e283d907.svg";
export { ForwardRef as ReactComponent };